import React from "react";
import { Mail, Linkedin, MapPin, ArrowUpRight } from "lucide-react";
import SectionHeader from "./SectionHeader";
import { useLanguage } from "../language/LanguageContext";
import SocialLinks, { EMAIL, LINKEDIN_URL } from "./ui/SocialLinks";
import Reveal from "./ui/Reveal";

const ContactSection = () => {
  const { translations } = useLanguage();
  const { contact } = translations;

  const rows = [
    {
      label: contact.email,
      value: EMAIL,
      href: `mailto:${EMAIL}`,
      icon: Mail,
      external: false
    },
    {
      label: contact.linkedin,
      value: "linkedin.com/in/renansfrr",
      href: LINKEDIN_URL,
      icon: Linkedin,
      external: true
    },
    {
      label: contact.location,
      value: translations.about.location,
      href: undefined,
      icon: MapPin,
      external: false
    }
  ];

  return (
    <section>
      <SectionHeader title={contact.title} />

      <Reveal>
        <p className="mb-8 text-lg text-dark-text leading-relaxed max-w-2xl">{contact.description}</p>
      </Reveal>

      <div className="space-y-3 mb-10 max-w-2xl">
        {rows.map((row, index) => {
          const Icon = row.icon;

          const inner = (
            <>
              <span className="flex items-center justify-center w-10 h-10 rounded-xl bg-accent/10 border border-accent/25 text-accent flex-shrink-0">
                <Icon size={18} />
              </span>
              <span className="min-w-0 flex-1">
                <span className="block text-xs uppercase tracking-wide text-dark-muted mb-0.5">
                  {row.label}
                </span>
                <span className="block text-dark-text break-all group-hover:text-dark-heading transition-colors duration-200">
                  {row.value}
                </span>
              </span>
              {row.href && (
                <ArrowUpRight
                  size={16}
                  className="text-dark-muted flex-shrink-0 transition-all duration-300 group-hover:text-accent group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
                />
              )}
            </>
          );

          return (
            <Reveal key={row.label} delay={index * 70}>
              {row.href ? (
                <a
                  href={row.href}
                  target={row.external ? "_blank" : undefined}
                  rel={row.external ? "noopener noreferrer" : undefined}
                  className="group card-interactive flex items-center gap-4 p-4 focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-dark-bg"
                >
                  {inner}
                </a>
              ) : (
                <div className="card flex items-center gap-4 p-4">{inner}</div>
              )}
            </Reveal>
          );
        })}
      </div>

      <Reveal delay={220}>
        <div className="pt-6 border-t border-dark-border">
          <p className="text-sm text-dark-muted mb-4">{contact.connect}</p>
          <SocialLinks size={18} variant="boxed" />
        </div>
      </Reveal>
    </section>
  );
};

export default ContactSection;
